import * as React from "react";
import { FieldValueLocaleMedia, Language } from "typings/index";
import {
    Dialog,
    Nav,
    DialogType,
    PrimaryButton,
    DialogFooter,
    DefaultButton,
    CommandBar,
    ICommandBarItemProps,
    IContextualMenuItem,
    ResponsiveMode
} from "office-ui-fabric-react/lib";
import { BaseFieldEditor } from "../helper";
import { connect } from "react-redux";
import { RootState } from "~/state";
import { getMediaByType, getAllMediaItems, getMultipleMedia } from "~/state/action";
import { folderToNavLink } from "~/components/media/helper";
import { loadMedia, loadMultipleMedia } from "~/state/media/action";
import ListMediaFiles, { mediaItemRender } from "~/components/media/ListMediaFiles";
import styled from "styled-components";
import { Map } from "~/../typings";
import { BaseMedia } from "typings/media";

export interface Props extends BaseFieldEditor {
    value: FieldValueLocaleMedia;
    languages: Language[];
    placeholder?: string;
}

interface State {
    showMediaPickerDialog: boolean;
    folderId: string;
    selectedItems: Map<string[]>;
    language: Language;
}
const DialogStyle = styled.div`
    display:flex;
    .ms-Dialog-content{
       
    }
    .ms-Nav-navItems {
        margin:6px;
    }
    .ms-List-page{
        grid-template-columns: 115px 115px 115px 115px;
        grid-gap: 28px;
        display: grid;
    }
    .item
    {
        cursor: pointer;
        display: block;
        width: 80px;
        height: 85px;
        margin: 5px;
        text-align: center;
        background-color: #f4f4f4;
        padding: 15px;
        position: relative;
        &.selected{
            background-color: lightgray;
        }
        h5{
            position: absolute;
            top: 77px;
            text-align: center;
            width: 92%;
            left: 0px;
            font-size: 12px;
            font-weight: 400;
            height: 33px;
            overflow: hidden;
            margin: 0px 5px;
        }
        i{
            font-size: 62px;
            color: deepskyblue;
        }
        &.image
        {
            img{
                max-height:61px;
                max-width: 80px;
            }
        }
           
    }
`;

const MediaList = styled.div`
    grid-template-columns: 150px 150px 150px 150px !important;
    grid-gap: 28px;
    display: grid;
    clear: both;
    > button{
        height: 150px;
        background: transparent;
        border: dashed 1px;
    }
`;

const MediaItem = styled.div`
    position: relative;
    img{
        max-width: 150px;
        max-height: 150px;
    }
    .ms-Button{
        position: absolute;
        top: 0px;
        right: 0px;
        border: 0px;
        min-width: 32px;
        padding: 0px;
        border-radius: 50px;
        background: white;
        font-size: 10px;
        min-height: 0px;
        margin: 3px;
    }
`;

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: RootState, ownProps: Props) =>
{
    return {
        folders: getMediaByType(state, "folder"),
        files: getAllMediaItems(state),
        rootState: state
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    loadMedia: (id: string) => dispatch(loadMedia(id)),
    loadMultipleMedia: (ids: string[]) => dispatch(loadMultipleMedia(ids)),
});

export class LocaleMedia extends React.Component<Props & StateProps, Partial<State>>
{
    state = {
        showMediaPickerDialog: false,
        folderId: undefined,
        selectedItems: this.props.value ? this.props.value.value : undefined,
        languages: this.props.languages, 
        language: this.props.languages[0]
    };

    componentWillMount = () =>
    {
        if (this.props.value && this.props.value.value) // load media resources for all languages
        {
            let ids: string[] = [];

            this.props.languages.forEach(c =>
            {
                const tmp: string[] = this.props.value && this.props.value.value ? this.props.value.value[c.name] : [];
                ids = [...ids, ...tmp];
            });

            this.props.loadMultipleMedia(ids);
        }

        const selectedItems: Map<string[]> | undefined = this.state.selectedItems ? this.state.selectedItems : undefined;
        if (selectedItems === undefined) // make an empty selectedItem object
        {
            const keyValuePair: Map<string[]> = {};
            this.props.languages.forEach(lang => keyValuePair[lang.name] = []);
            this.setState({ selectedItems: keyValuePair });
        }
    }

    onLinkClick = (id: string) => (e: React.MouseEvent<HTMLElement>) =>
    {
        e.preventDefault();
        this.props.loadMedia(id);
        this.setState({ folderId: id });
        return false;
    }

    toggleMediaPickerDialog = () => this.setState({ showMediaPickerDialog: !this.state.showMediaPickerDialog });

    onItemClick = (type: string, id: string) => () =>
    {
        if (type === "folder")
        {
            this.props.loadMedia(id);
            this.setState({ folderId: id });
        }
        else
        {
            const value: Map<string[]> = this.state.selectedItems ? { ...this.state.selectedItems } : {} as Map<string[]>;

            const selectedItems = value[this.state.language.name];
            const item = selectedItems.find(x => x === id);
            const items = item ? selectedItems.filter(x => x !== id ) : [...selectedItems, id];
            value[this.state.language.name] = items;
            this.setState({ selectedItems: value });
            
        }
    }

    onSave = (selectedItems = this.state.selectedItems) => () =>
    {
        const fieldValue: FieldValueLocaleMedia = { ...this.props.value, value: selectedItems };
        this.props.onValueChange(fieldValue);
        this.setState({ showMediaPickerDialog: false, selectedItems });
    }

    dialog = () =>
    {
        if (this.state.showMediaPickerDialog)
        {
            const { links } = folderToNavLink(this.props.folders, this.onLinkClick, this.state.folderId, null);
            const files = this.props.files.filter(x => x.parentId === this.state.folderId);
            return (
                <Dialog onDismiss={this.toggleMediaPickerDialog} hidden={false}
                   maxWidth="auto"
                   minWidth="730"
                    responsiveMode={ResponsiveMode.xLarge}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: "Media Picker",
                    }}>
                    <DialogStyle>
                        <Nav className="media-navigation" groups={[{ links }]} />
                        <ListMediaFiles
                            files={files}
                            onItemClick={this.onItemClick}
                            selected={this.state.selectedItems && this.state.selectedItems[this.state.language.name] ? this.state.selectedItems[this.state.language.name] : undefined}
                        />
                    </DialogStyle>
                    <DialogFooter>
                        <PrimaryButton onClick={this.onSave()} text="Save" />
                        <DefaultButton onClick={this.toggleMediaPickerDialog} text="Cancel" />
                    </DialogFooter>
                </Dialog>
            );
        }
    }

    onItemDelete = (id: string) => () =>
    {
        const selectedItems: Map<string[]> = this.state.selectedItems ? {...this.state.selectedItems} : {} as Map<string[]>;
        selectedItems[this.state.language.name] = selectedItems[this.state.language.name].filter(x => x !== id);
        this.onSave(selectedItems)();
       
    }

    onChangeLanguage = (ev: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item: IContextualMenuItem) =>
    {
        const language: Language = item.data;
        this.setState({ language });
    }

    renderMedia = (media: BaseMedia[]) =>
    {
        return media.map((media, index) =>
        {
            return <MediaItem key={index}>
                <DefaultButton onClick={this.onItemDelete(media.id)} iconProps={{ iconName: "Delete" }}></DefaultButton>
                {mediaItemRender(media, undefined, undefined, true)}
            </MediaItem>;
        });
    }

    render()
    {
        const { language, languages } = this.state;

        const commandBarOptions: ICommandBarItemProps[] = languages.map(lang => (
            {
                key: lang.name,
                name: lang.name,
                data: lang,
                checked: lang.name === language.name,
                onClick: this.onChangeLanguage
            }
        ));
        const value: Map<string[]> = this.state.selectedItems ? this.state.selectedItems : {} as Map<string[]>;
        const ids: string[] = value[this.state.language.name];
        const media:BaseMedia[] = value ? getMultipleMedia(this.props.rootState, ids ? ids : []) : [];
        return (
            <div>
                <CommandBar
                    style={{ background: "transparent" }}
                    items={commandBarOptions}
                />
                <MediaList>
                    {this.renderMedia(media)}
                    {(this.props.field.max !== undefined && this.props.field.max > 0 && media && media.length >= this.props.field.max) ? null :
                        (<DefaultButton
                            disabled={this.props.disabled}
                            iconProps={{ iconName: "Add" }}
                            onClick={this.toggleMediaPickerDialog}
                        />)
                    }
                </MediaList>
                {this.dialog()}
            </div>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(LocaleMedia);


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/mediaPicker/LocaleMedia.tsx